import { post } from './client'
import type { BackendMeta } from './types'

export type CreatePropertyFromPrompt = BackendMeta<
  '/api/workspaces/{workspace_id}/projects/{project_id}/properties/from_prompt',
  'post'
>

export type CreatePropertyFromPromptParams = {
  workspaceId: string
  projectId: string
  prompt: string
}

export const createPropertyFromPrompt = async ({
  projectId,
  prompt,
  workspaceId,
}: CreatePropertyFromPromptParams) =>
  post<
    CreatePropertyFromPrompt['body'],
    CreatePropertyFromPrompt['successResponse'],
    CreatePropertyFromPrompt['path']
  >(`/api/workspaces/${workspaceId}/projects/${projectId}/properties/from_prompt`, {
    prompt,
  })
